let filters = {
  //验证是否过期失效
  isExpiresAt(expiresAt){
    var expDate = new Date(expiresAt);
    var now = new Date();
    return (expDate.getTime() < now.getTime());
  },
  //得到server接口地址
  getServerUrl(type){
      let serverAddress = JSON.parse(localStorage.getItem('serverAddress'));
      let addr = null;
      if(serverAddress) {
          serverAddress.forEach((item, index) => {
              if (type == item.type) {
                  addr = item.addr.indexOf('https') != -1 ? item.addr : `https://${item.addr}`;
              }
          });
          return addr;
      }else{
          return false
      }
  },
  /*******得到websocket地址*******/
  getWServerUrl(type){
    let serverAddress = JSON.parse(localStorage.getItem('serverAddress'));
    let addr = null;
   if(serverAddress){
      serverAddress.forEach((item,index)=>{
        if(type == item.type){
          addr = item.addr.indexOf('wss') != -1 ? item.addr: `wss://${item.addr}`;
        }
      });
      return addr;
   }else{
      return false
   }
  },
  //设置uuid，随机生成
  uuid(len, radix){
    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    var uuid = [], i;
    radix = radix || chars.length;

    if (len) {
      // Compact form
      for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random()*radix];
    } else {
      // rfc4122, version 4 form
      var r;
      // rfc4122 requires these characters
      uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
      uuid[14] = '4';
      // Fill in random data.  At i==19 set the high bits of clock sequence as
      // per rfc4122, sec. 4.1.5
      for (i = 0; i < 36; i++) {
        if (!uuid[i]) {
          r = 0 | Math.random()*16;
          uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
        }
      }
    }
    return uuid.join('');
  },
  uid(len){
      var chars = '0123456789'.split('');
      var uid = [],i;
      for (i = 0; i < len; i++) uid[i] = chars[0 | Math.random()*chars.length];
      return uid.join('');
  },
  timeToMinute(times){
    var result = '00:00:00';
    var hour,minute,second;
    if (times > 0) {
      hour = Math.floor(times / 3600);
      if (hour < 10) {
        hour = "0"+hour;
      }
      minute = Math.floor((times - 3600 * hour) / 60);
      if (minute < 10) {
        minute = "0"+minute;
      }
      second = Math.floor((times - 3600 * hour - 60 * minute) % 60);
      if (second < 10) {
        second = "0"+second;
      }
      if (hour == '00') {
        result = minute+':'+second;
      } else if (minute == '00'){
        result = hour+':'+minute+':'+second;
      } else {
        result = second;
      }
    }
    return result;
  },
  getElementLeft(element){
    var actualLeft = element.offsetLeft;
    var current = element.offsetParent;
    while (current !== null){
      actualLeft += current.offsetLeft;
      current = current.offsetParent;
    }
    return actualLeft;
  },
  str2Uint8(str) {
    var buf = new ArrayBuffer(str.length); // 每个字符占用2个字节
    var bufView = new Uint8Array(buf);
    for (var i=0, strLen=str.length; i<strLen; i++) {
      bufView[i] = str.charCodeAt(i);
    };
    return bufView;
  },	
};
export default  filters
